var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"watermark",staticClass:"watermark"},_vm._l((_vm.waterList),function(item,index){return _c('div',{key:index,staticClass:"water-item",style:({
      top: ((item.top) + "px"),
      left: ((item.left) + "px"),
    })},[(_vm.marketer_name)?_c('div',{staticClass:"flex flex-col"},[_c('span',[_vm._v(_vm._s(item.text))]),(item.hasTime)?_c('span',[_vm._v(_vm._s(_vm.$Tool.formatDate(new Date())))]):_vm._e()]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }